/**
 * Minimalny reaktywny store — wzorzec obserwatora, bez bibliotek.
 *
 * Stan globalny w Quizotece to trzy małe store'y. Wszystko poza nimi jest
 * stanem lokalnym komponentu; dane z API trzyma fetch-controller.
 */
export function createStore(initial) {
  let state = initial;
  const listeners = new Set();

  return {
    get() {
      return state;
    },

    set(next) {
      const previous = state;
      state = typeof next === 'function' ? next(state) : { ...state, ...next };
      if (state !== previous) {
        for (const listener of listeners) listener(state);
      }
    },

    /** @returns {() => void} funkcja odsubskrybowania */
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}

/**
 * Kontroler spinający store z cyklem życia komponentu Lit.
 *
 * Subskrypcja powstaje w hostConnected i znika w hostDisconnected — bez tego
 * odłączony komponent trzymałby referencję i przeciekał.
 *
 * @example
 *   #session = new StoreController(this, sessionStore);
 *   render() { return html`${this.#session.value.user?.name}`; }
 */
export class StoreController {
  #host;
  #store;
  #unsubscribe;

  constructor(host, store) {
    this.#host = host;
    this.#store = store;
    host.addController(this);
  }

  get value() {
    return this.#store.get();
  }

  hostConnected() {
    this.#unsubscribe = this.#store.subscribe(() => this.#host.requestUpdate());
  }

  hostDisconnected() {
    this.#unsubscribe?.();
    this.#unsubscribe = undefined;
  }
}
